import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

interface ForgotPasswordScreenProps {
  onBack: () => void;
}

const ForgotPasswordScreen: React.FC<ForgotPasswordScreenProps> = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error', text: string } | null>(null);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage(null);

    const cleanEmail = email.replace(/\s/g, '').trim();

    try {
      await resetPassword(cleanEmail);
      setMessage({ 
          type: 'success', 
          text: 'Si cet email existe, un lien de réinitialisation vous a été envoyé. Vérifiez vos spams.' 
      });
    } catch (err: any) {
      setMessage({ type: 'error', text: err.message || "Une erreur est survenue." });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center h-[100dvh] bg-gray-100 p-4 overflow-y-auto overflow-x-hidden pt-safe-top pb-safe-bottom">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-lg">
        <h1 className="text-3xl font-bold text-center text-green-600 mb-2">Mot de passe oublié</h1>
        <p className="text-center text-gray-500 mb-8">
            Entrez votre email pour recevoir les instructions de réinitialisation.
        </p>

        {message && (
            <div className={`p-4 mb-6 rounded-lg text-sm ${message.type === 'success' ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
                {message.text}
            </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="email" className="text-sm font-semibold text-gray-700">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="votre@email.com"
              required
              className="w-full p-3 mt-1 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 bg-white text-gray-900"
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-3 font-bold text-white bg-green-600 rounded-full hover:bg-green-700 transition-colors disabled:bg-green-300 shadow-md"
          >
            {isLoading ? 'Envoi...' : 'Envoyer le lien'}
          </button>
        </form>

        <div className="mt-6 text-center">
            <button 
                onClick={onBack}
                className="text-sm text-gray-600 font-semibold hover:text-green-600 hover:underline"
            >
                Retour à la connexion
            </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordScreen;